<template>
  <transition name="fade">
    <div class="connectivity-notice" v-show="showAppUpdateNotice">
      <i class="fas fa-times mr-2" v-on:click="onDismiss"></i>
      <span class="ml-2">App updated</span>
      <button v-on:click="onReload" class="notice ml-4">Reload</button>
    </div>
  </transition>
</template>
<script>

import { mapState } from 'vuex'

export default {
  computed: mapState({
    showAppUpdateNotice: state => state.showAppUpdateNotice
  }),
  methods: {
    onReload () {
      this.$store.commit('hideAppUpdateNotice')
      this.$store.commit('performAppUpdate')
    },
    onDismiss () {
      this.$store.commit('hideAppUpdateNotice')
      this.$store.commit('declineAppUpdate')
    }
  }
}
</script>
